import { render, staticRenderFns } from "./rework.vue?vue&type=template&id=b2f548c4&scoped=true&"
import script from "./rework.vue?vue&type=script&lang=js&"
export * from "./rework.vue?vue&type=script&lang=js&"
import style0 from "./rework.vue?vue&type=style&index=0&lang=css&"
import style1 from "./rework.vue?vue&type=style&index=1&id=b2f548c4&scoped=true&lang=css&"
import style2 from "./rework.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f548c4",
  null
  
)

export default component.exports